import React, { useState } from 'react';

const Connexion = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Add authentication logic here
        console.log('Email:', email);
        console.log('Password:', password);
    };

    return (
        <div className="home-bg min-h-screen flex items-center justify-center bg-gray-100">
            <div className="flex justify-center mt-4 w-full">
                <div className="w-full md:w-2/3 lg:w-1/2">
                    <div className="form-card bg-white shadow-lg rounded-lg p-8">
                        <div className="text-center mb-6">
                            <h2 className="text-3xl font-bold text-gray-800">Se Connecter</h2>
                        </div>
                        <div className="text-center mb-6">
                            <p className="text-gray-600">Saisissez vos informations de connexion pour accéder à votre page</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-6">
                                <label htmlFor="formEmail" className="block text-gray-700 mb-2">Email:</label>
                                <input
                                    type="email"
                                    id="formEmail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="input input-bordered w-full px-3 py-2"
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="formPassword" className="block text-gray-700 mb-2">Password:</label>
                                <input
                                    type="password"
                                    id="formPassword"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    className="input input-bordered w-full px-3 py-2"
                                />
                            </div>
                            <div className='flex justify-end'>
                                <button type="submit" className="btn btn-neutral rounded-full  btn-sm">
                                    Se connecter
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connexion;